import { render, staticRenderFns } from "./ModalUpdateExpiringDate.vue?vue&type=template&id=147bd9c0&"
import script from "./ModalUpdateExpiringDate.vue?vue&type=script&lang=ts&"
export * from "./ModalUpdateExpiringDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports